import React from 'react';
import NumberHelper from 'helpers/number-helper';
import BaseTeamDetails from './base-team-details';

class TeamDetailsComponent extends BaseTeamDetails {
    render() {
        const totalValue = this.getTeamTotalValue();
        return (
            <span className="spread-text">
                Spread: <strong>{NumberHelper.float(totalValue, 3)}</strong>
            </span>
        );
    }
}

export {TeamDetailsComponent};
